import * as React from "react";
// UI Frameworks
import { Form, Typography } from "antd";
import { FormComponentProps } from "antd/lib/form";
// Shared components
import Input from "components/Input";
import Button from "components/Button";
// Hooks and utilities
import { normalizeNumbers } from "helpers/persian";
// Styles
import styles from "./index.module.scss";

const { Text } = Typography;

interface ISubmitData {
	mobile: string;
}

interface IProps extends FormComponentProps {
	loading: boolean;
	onSubmit: (data: ISubmitData) => void;
}

const GetMobile: React.FC<IProps> = props => {
	const { getFieldDecorator, getFieldValue } = props.form;
	const [warn, setWarn] = React.useState(false);
	const username = getFieldValue("mobile") || "";

	React.useEffect(() => {
		setWarn(username.startsWith("+"));
	}, [username]);

	function handleSubmit(e: React.FormEvent<HTMLFormElement>): void {
		e.preventDefault();

		props.form.validateFieldsAndScroll((err, values) => {
			if (!err) {
				props.onSubmit(values);

				return;
			}
		});
	}

	return (
		<Form className={styles["send-sms-form"]} onSubmit={handleSubmit}>
			<Form.Item
				label={`لطفا نام کاربری (ایمیل / شماره موبایل) خود را وارد کنید`}
				help={warn && <Text type="danger">برای بازنشانی رمز عبور از ایمیل استفاده کنید.</Text>}
			>
				{getFieldDecorator("mobile", {
					normalize: normalizeNumbers,
					rules: [
						{
							required: true,
							transform: value => (value ? value.trim() : value),
							message: "لطفا نام کاربری خود را وارد نمایید",
						},
					],
				})(<Input className="ltr" />)}
			</Form.Item>

			<Form.Item className="button-center">
				<Button htmlType="submit" primary loading={props.loading}>
					ارسال کد تایید
				</Button>
			</Form.Item>
		</Form>
	);
};

export default Form.create<IProps>()(React.memo(GetMobile));
